
import axios from 'axios'

const baseURL = ''

export default axios.create({
  baseURL
  
})
